import { render, staticRenderFns } from "./PhotoUploader.vue?vue&type=template&id=0d99b944&scoped=true&"
import script from "./PhotoUploader.vue?vue&type=script&lang=js&"
export * from "./PhotoUploader.vue?vue&type=script&lang=js&"
import style0 from "./PhotoUploader.vue?vue&type=style&index=0&id=0d99b944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d99b944",
  null
  
)

export default component.exports